<template>
  <div class="page">
    <h2 class="page-title">修缮进展</h2>
    <div class="filter-card">
      <el-form :model="query" size="small" label-width="68px" class="filter-form">
        <el-row :gutter="12">
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="泉井名称"><el-input v-model="query.wellName" placeholder="输入泉井名称" clearable /></el-form-item>
          </el-col>
          <el-col :xl="8" :lg="10" :md="12" :sm="24" :xs="24">
            <el-form-item label="发布时间">
              <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable />
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item class="filter-actions">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-card">
      <div class="table-toolbar">
        <el-button type="primary" size="small" @click="openCreate">新增</el-button>
        <el-button size="small" @click="exportList">导出</el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="wellName" label="泉井名称" min-width="150" show-overflow-tooltip />
        <el-table-column prop="content" label="进展内容" min-width="280" show-overflow-tooltip />
        <el-table-column label="图片" width="90">
          <template slot-scope="scope">
            <el-image v-if="scope.row.images && scope.row.images.length" :src="resolveImageUrl(scope.row.images[0])" :preview-src-list="resolveImageList(scope.row.images)" style="width:40px;height:40px;border-radius:4px" fit="cover" />
            <span v-else class="empty-tip">无</span>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" width="170"><template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template></el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <div class="action-bar">
              <span class="action-text edit" @click="openEdit(scope.row)">修改</span>
              <span class="action-text delete" @click="handleDelete(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, total" :total="total" :current-page.sync="query.pageNum" :page-size="query.pageSize" @current-change="loadData" style="margin-top:16px;text-align:right" />
    </div>

    <el-dialog :title="dialogMode === 'create' ? '新增修缮进展' : '修改修缮进展'" :visible.sync="dialogVisible" width="640px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="泉井名称" prop="wellName"><el-input v-model="form.wellName" placeholder="请输入泉井名称" /></el-form-item>
        <el-form-item label="进展内容" prop="content"><el-input v-model="form.content" type="textarea" :rows="4" placeholder="请输入进展内容" /></el-form-item>
        <el-form-item label="图片">
          <div class="img-upload-list">
            <div v-for="(img, idx) in form.imageList" :key="idx" class="img-item">
              <el-image :src="resolveImageUrl(img)" fit="cover" class="img-thumb" />
              <span class="img-del" @click="form.imageList.splice(idx, 1)">×</span>
            </div>
            <el-upload v-if="form.imageList.length < 9" class="img-uploader" action="" :show-file-list="false" :before-upload="handleUpload" accept="image/*">
              <div class="img-add">+</div>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchRepairProgress, addRepairProgress, updateRepairProgress, deleteRepairProgress, uploadImage } from '@/api'
import { resolveImageUrl, resolveImageList } from '@/utils/media'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      dateRange: [],
      query: { pageNum: 1, pageSize: 10, wellName: '' },
      dialogVisible: false,
      dialogMode: 'create',
      form: { id: null, wellName: '', content: '', imageList: [] },
      rules: {
        wellName: [{ required: true, message: '请输入泉井名称', trigger: 'blur' }],
        content: [{ required: true, message: '请输入进展内容', trigger: 'blur' }]
      }
    }
  },
  watch: {
    'query.wellName'() { this.query.pageNum = 1; this.loadData() }
  },
  created() { this.loadData() },
  methods: {
    resolveImageUrl,
    resolveImageList,
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0]
          params.endTime = this.dateRange[1]
        }
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k] })
        const res = await fetchRepairProgress(params)
        this.tableData = res.records || []
        this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() { this.query.pageNum = 1; this.loadData() },
    handleReset() {
      this.dateRange = []
      this.query = { pageNum: 1, pageSize: 10, wellName: '' }
      this.loadData()
    },
    openCreate() {
      this.dialogMode = 'create'
      this.form = { id: null, wellName: '', content: '', imageList: [] }
      this.dialogVisible = true
    },
    openEdit(row) {
      this.dialogMode = 'edit'
      this.form = { id: row.id, wellName: row.wellName || '', content: row.content || '', imageList: Array.isArray(row.images) ? [...row.images] : [] }
      this.dialogVisible = true
    },
    async handleUpload(file) {
      try {
        const url = await uploadImage(file)
        if (url) this.form.imageList.push(url)
      } catch (e) { this.$message.error('图片上传失败') }
      return false
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        const payload = { wellName: this.form.wellName, content: this.form.content, images: this.form.imageList }
        if (this.dialogMode === 'create') {
          await addRepairProgress(payload)
          this.$message.success('新增成功')
        } else {
          await updateRepairProgress({ ...payload, id: this.form.id })
          this.$message.success('修改成功')
        }
        this.dialogVisible = false
        this.loadData()
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该修缮进展记录吗？', '删除确认', { type: 'warning' })
        await deleteRepairProgress(row.id)
        this.$message.success('已删除')
        this.loadData()
      } catch (e) {}
    },
    exportList() {
      const headers = ['ID', '泉井名称', '进展内容', '发布时间']
      const rows = this.tableData.map(r => [r.id, r.wellName, r.content, this.formatDateTime(r.createdAt)])
      const csv = [headers, ...rows].map(items => items.map(v => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`).join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `修缮进展_${new Date().toISOString().slice(0, 10)}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    formatDateTime(v) { return v ? String(v).replace('T', ' ') : '-' }
  }
}
</script>

<style scoped>
.filter-form ::v-deep .el-row { width: 100%; }
.filter-form ::v-deep .el-form-item { margin-bottom: 12px; }
.filter-form ::v-deep .el-input,
.filter-form ::v-deep .el-date-editor { width: 100%; }
.filter-form ::v-deep .filter-actions .el-form-item__content { display: flex; gap: 8px; }
.table-toolbar { display: flex; justify-content: flex-end; gap: 10px; margin-bottom: 12px; }
.action-bar { display: flex; align-items: center; gap: 10px; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.edit { color: #409eff; }
.action-text.delete { color: #f56c6c; }
.empty-tip { color: #999; }
.img-upload-list { display: flex; flex-wrap: wrap; gap: 8px; }
.img-item { position: relative; width: 80px; height: 80px; }
.img-thumb { width: 80px; height: 80px; border-radius: 6px; border: 1px solid #e5e7eb; }
.img-del { position: absolute; top: -8px; right: -8px; width: 20px; height: 20px; background: #f56c6c; color: #fff; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 14px; cursor: pointer; line-height: 1; z-index: 2; }
.img-del:hover { background: #e53e3e; }
.img-uploader .img-add { width: 80px; height: 80px; border: 1.5px dashed #d0d7de; border-radius: 6px; display: flex; align-items: center; justify-content: center; font-size: 28px; color: #b0b8c4; cursor: pointer; background: #fafafa; }
.img-uploader .img-add:hover { border-color: #409eff; color: #409eff; }
</style>
